"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetMessagesState = exports.resetCurrentChat = exports.setAsGroupChat = exports.setAllChats = exports.setNextPage = exports.addMessageAction = exports.sendMessageAction = exports.setMessagesCount = exports.setChatUsers = exports.setChatInitiator = exports.setChatReceiver = exports.setChatFlight = exports.setCurrentChatId = exports.setCurrentChat = exports.CHAT_DEFAULT_STATE = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
exports.CHAT_DEFAULT_STATE = {
    allChats: [],
    currentChat: {
        id: null,
        flight: null,
        receiver: null,
        initiator: null,
        messages: [],
        group_chat_users: [],
        messages_count: null,
        next_page: 2,
        isGroupChat: false
    },
};
const messageSlice = (0, toolkit_1.createSlice)({
    name: 'message',
    initialState: exports.CHAT_DEFAULT_STATE,
    reducers: {
        setCurrentChat: (state, action) => {
            return {
                ...state,
                currentChat: action.payload
            };
        },
        setCurrentChatId: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    id: action.payload
                }
            };
        },
        setChatFlight: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    flight: action.payload
                }
            };
        },
        setChatReceiver: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    receiver: action.payload
                }
            };
        },
        setChatInitiator: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    initiator: action.payload
                }
            };
        },
        setChatUsers: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    group_chat_users: action.payload
                }
            };
        },
        setMessagesCount: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    messages_count: action.payload
                }
            };
        },
        sendMessage: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    messages: [...(state.currentChat.messages || []), action.payload]
                }
            };
        },
        setNextPage: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    next_page: action.payload
                }
            };
        },
        addMessage: (state, action) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    messages: [...action.payload, ...state.currentChat.messages || []]
                }
            };
        },
        setAllChats: (state, action) => {
            return {
                ...state,
                allChats: action.payload
            };
        },
        setAsGroupChat: (state) => {
            return {
                ...state,
                currentChat: {
                    ...state.currentChat,
                    isGroupChat: true
                },
            };
        },
        resetCurrentChat: (state) => {
            return {
                ...state,
                currentChat: exports.CHAT_DEFAULT_STATE.currentChat,
            };
        },
        resetMessagesState: () => {
            return exports.CHAT_DEFAULT_STATE;
        }
    }
});
exports.default = messageSlice.reducer;
exports.setCurrentChat = messageSlice.actions.setCurrentChat;
exports.setCurrentChatId = messageSlice.actions.setCurrentChatId;
exports.setChatFlight = messageSlice.actions.setChatFlight;
exports.setChatReceiver = messageSlice.actions.setChatReceiver;
exports.setChatInitiator = messageSlice.actions.setChatInitiator;
exports.setChatUsers = messageSlice.actions.setChatUsers;
exports.setMessagesCount = messageSlice.actions.setMessagesCount;
exports.sendMessageAction = messageSlice.actions.sendMessage;
exports.addMessageAction = messageSlice.actions.addMessage;
exports.setNextPage = messageSlice.actions.setNextPage;
exports.setAllChats = messageSlice.actions.setAllChats;
exports.setAsGroupChat = messageSlice.actions.setAsGroupChat;
exports.resetCurrentChat = messageSlice.actions.resetCurrentChat;
exports.resetMessagesState = messageSlice.actions.resetMessagesState;
